import React, { useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { ReactSVG } from "react-svg";
import BackButtonImage from "../images/buttons/back-button-arrow.svg";
import BackButtonWhite from "../images/buttons/back-button-white.svg";

const BackButton = (data) => {
  const { backurl } = data;
  const [hover, setHover] = useState(false);
  return (
    <div className="zoom-8 fixed flex left-0 bottom-[30%] xl:w-[111px] xl:h-[96px] w-[185px] items-center align-middle justify-center h-[160px] bg-opacity-50 bg-white rounded-tr-3xl rounded-br-3xl z-10">
      <Link
        className="relative flex items-center align-middle justify-center xl:w-[54px] xl:h-[54px] w-[90px] h-[90px]"
        to={backurl}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <img
            alt={"Back to previous page"}
          src={BackButtonImage}
          className={classnames(
            "absolute transition-opacity duration-300",
            hover ? "opacity-0 " : "opacity-100"
          )}
        />
        <img
            alt={"Back to previous page"}
          src={BackButtonWhite}
          className={classnames(
            "absolute transition-opacity duration-300",
            hover ? "opacity-100" : "opacity-0"
          )}
        />
      </Link>
    </div>
  );
};

export default BackButton;
